import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { features_plan } from '../../core/types';
import { EmittersService } from '../../core/utils/emitters.service';
import { UpperCasePipe } from '@angular/common';

export interface BuyPlan {
	opt: features_plan;
	necessary: number;
	available: number;
}

@Component({
	selector: 'app-buy-plan-modal',
	templateUrl: './buy-plan-modal.component.html',
	styleUrls: ['./buy-plan-modal.component.scss'],
	imports: [UpperCasePipe, TranslateModule]
})
export class BuyPlanModalComponent {
	translateService = inject(TranslateService);
	private _router = inject(Router);

	buyPlanParams!: BuyPlan;

	constructor() {
		const _emittersService = inject(EmittersService);

		_emittersService.buyPlan.subscribe((res) => (this.buyPlanParams = res));
	}

	go(): void {
		let url = this._router.url;
		this._router.navigate(['/account/plans'], { queryParams: { returnUrl: url } });
	}

	transformText(): string {
		if (this.buyPlanParams.opt) {
			let text: any = this.buyPlanParams.opt;
			if (this.translateService.currentLang === 'en') {
				if (this.buyPlanParams.opt === 'organizaciones') text = 'organizations';
				if (this.buyPlanParams.opt === 'espacios') text = 'workspaces';
				if (this.buyPlanParams.opt === 'procesos') text = 'process';
				if (this.buyPlanParams.opt === 'transacciones') text = 'transactions';
				if (this.buyPlanParams.opt === 'usuarios') text = 'users';
			}
			return text;
		}
		return '';
	}
}
